const PATH_PREFIX = '/admin/plans/:companyID';

export default [
  {
    name: 'plans.dashboard',
    path: `${PATH_PREFIX}/`,
  },
  {
    name: 'plans.administrators',
    path: `${PATH_PREFIX}/administrators`,
  },
  {
    name: 'plans.access_levels',
    path: `${PATH_PREFIX}/access-levels`,
  },
  {
    name: 'plans.access_level',
    path: `${PATH_PREFIX}/access-levels/:docID`,
  },
  {
    name: 'plans.subscriptions',
    path: `${PATH_PREFIX}/subscriptions`,
  },
];
